var moment = require('moment');

angular.module('account.index', [
  'common.header',
  'common.footer',
  'security.authorization',
  'services.editionChecker'
]);

angular.module('account.index').config(["$stateProvider", "securityAuthorizationProvider", function($stateProvider, securityAuthorizationProvider){
  $stateProvider
    .state('account', {
      url: '/account',
      title: 'Account Area',
      views: {
        header: {
          template: require('../common/header/header.tpl.html'),
          controller: 'HeaderCtrl'
        },
        main: {
          template: require('./account.tpl.html'),
          controller: 'AccountCtrl'
        },
        footer: {
          template: require('../common/footer/footer.tpl.html'),
          controller: 'FooterCtrl'
        }
      },
      resolve: {
        user: ["User", "editionChecker", "$location", "$q", function (User, editionChecker, $location, $q) {
          return User.current().$promise.then(function (user) {
            if (!user._id) {
              $location.path('/login');
              return $q.reject('unauthorized');
            }
            editionChecker.check(user);
            return user;
          });
        }],
        initSearch: ["searchService", "Article", function (searchService, Article) {
          searchService.setSearchFn(Article.search);
          searchService.setRedirectBase('/account/edit-article');
        }]
      }
    });
}]);

angular.module('account.index').controller('AccountCtrl', ["$scope", "user", function($scope, user){
  // editionChecker.check();
  $scope.dayOfYear = moment().format('DDD');
  $scope.dayOfMonth = moment().format('D');
  $scope.weekOfYear = moment().format('w');
  $scope.dayOfWeek = moment().format('d');
  $scope.weekYear = moment().format('gg');
  $scope.hourOfDay = moment().format('H');

}]);



// WEBPACK FOOTER //
// ./client/src/app/account/account.js